import { observer } from "mobx-react";
import "./approve-plan-onboarding-screen.scss";
import useDashboardTranslation from "../../../../dashboard-translation/hooks/dashboard-translation-hook";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import almostDone from "../../../../images/onboarding/almost-done.png";
import { IStepComponent } from "../../onboarding-page";
import ApprovePlanScreenStore from "../../stores/approve-plan-screen-store";
import OnBoardingScreenTitle from "../onboarding-screen-title/onboarding-screen-title";
import OnBoardingButton from "../onboarding-button/onboarding-button";
import {BUTTON_VARIANTS} from "../../../../components/inputs/button-variants";
import {Button} from "../../../../components/inputs/button/button";


const ApprovePlanOnboardingScreen: React.FC<IStepComponent> = observer((props) => {
    const store = props.store as ApprovePlanScreenStore;
    const scope = "dashboard-onboarding";
    const { getTranslation } = useDashboardTranslation();
    // TODO: this flag still not implemented for existing merchant. We should always show it for new merchants with coverage plan.
    const showNotConfiguredCoveragePlanWarning = store.isCoveragePlanSelected && !store.shouldHideCoverage;

    const BackBtn = <Button
        text={getTranslation('BACK', scope)}
        variant={BUTTON_VARIANTS.Transparent}
        onClick={() => store.previousStep()}
    />

    return (
        <div className="approve-plan-onboarding-screen">
            <div className="approve-plan-onboarding-screen-body">
                <div className="approve-plan-onboarding-screen-body-title-container">
                    <OnBoardingScreenTitle
                        titleText={getTranslation('ALMOST_DONE_SCREEN_TITLE',scope)}
                        descriptionText={getTranslation('ALMOST_DONE_SCREEN_SUBTITLE', scope)}
                    />
                </div>
                {!showNotConfiguredCoveragePlanWarning && (
                    <>
                        <OnBoardingButton
                            buttonText={getTranslation('FINISH_AND_ACTIVATE_PORTAL', scope)}
                            onClick={store.approvePlan}
                            paddingTop={32}
                            isLoading={store.isLoading}
                        />
                        {BackBtn}
                    </>
                )}

                <img src={almostDone} alt="almost done" />
            </div>
            {showNotConfiguredCoveragePlanWarning &&
                <>
                    <div className="approve-plan-onboarding-screen-warning-note">
                        <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation('COVERAGE_WARNING_TITLE', scope)}</FontBody1>
                        <FontBody1 color={FONT_COLOR.PRIMARY2}>{getTranslation('COVERAGE_WARNING_DESCRIPTION', scope)}</FontBody1>
                    </div>

                    <OnBoardingButton
                        buttonText={getTranslation('FINISH_AND_ACTIVATE_PORTAL', scope)}
                        onClick={store.approvePlan}
                        paddingTop={32}
                        paddingBottom={10}
                        isLoading={store.isLoading}
                    />

                    {BackBtn}
                </>
            }
        </div>
    );

});

export default ApprovePlanOnboardingScreen;